import { SplitterPaneProps } from '@progress/kendo-react-layout';
import React from 'react';

export interface TwoColsSplitterProps {
    leftCol: React.ReactNode;
    rightCol: React.ReactNode;
    orientation: 'horizontal' | 'vertical';
    alignmentValues?: Array<SplitterPaneProps>;
    onResize?: () => void;
    className?: string;
}

export enum ViewOption {
    FULL = 'full',
    LEFT = 'left',
    TOP = 'top',
}
